/**
 * API utility functions
 */

export const sendMessage = async (message, config) => {
  if (!config.apiUrl) {
    throw new Error("API URL not configured");
  }

  try {
    const response = await fetch(config.apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(config.apiKey && { Authorization: `Bearer ${config.apiKey}` }),
        ...(config.userId && { "X-User-ID": config.userId }),
      },
      body: JSON.stringify({
        message,
        userId: config.userId,
        userName: config.userName,
        userEmail: config.userEmail,
        timestamp: new Date().toISOString(),
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.reply || data.message || data.response;
  } catch (error) {
    console.error("Chat API error:", error);
    throw error;
  }
};


export const createSession = async (config) => {
  // Initialize chat session if needed
  if (config.sessionUrl) {
    try {
      const response = await fetch(config.sessionUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(config.apiKey && { Authorization: `Bearer ${config.apiKey}` }),
        },
        body: JSON.stringify({
          userId: config.userId,
          userName: config.userName,
          userEmail: config.userEmail,
        }),
        credentials: "include",
      });

      const data = await response.json();
      return data.sessionId;
    } catch (error) {
      console.error("Session creation error:", error);
      return null;
    }
  }
  return null;
};

/**
 * Fetches agent configuration from the deploy-agent endpoint
 * @param {string} apiBaseUrl - Base URL for the API
 * @param {string} orgId - Organization ID
 * @returns {Promise<object>} Agent configuration object
 */
export const fetchAgentConfig = async (apiBaseUrl, orgId) => {
  if (!apiBaseUrl || !orgId) {
    throw new Error("apiBaseUrl and orgId are required");
  }

  try {
    const url = `${apiBaseUrl.replace(/\/$/, '')}/api/v1/deploy-agent/${orgId}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Failed to fetch agent configuration:", error);
    throw error;
  }
};
